import { watchForSettingChanges } from 'go-modules/models/common/client.settings';

/* @ngInject */
export const updateSettings = ($interval: ng.IIntervalService) => {
	watchForSettingChanges(1000 * 60 * 15, $interval);
};
